import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type UserModel from './user.ts';
import type EmployeeModel from './employee.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class NotificationHistoryModel extends Model {
  @attr declare noteSubtype: string;
  @attr declare noteType: string;
  @attr declare createdAt: string;
  @attr declare toEmail: string;
  @attr declare fromEmail: string;
  @attr declare templateId: string;
  @attr declare templateSubstitutions: Record<string, string> | null;
  @attr declare noteSuccessful: boolean;
  @attr declare trackingToken: string;
  @attr declare firstOpenedAt: string | null;
  @attr declare openCount: number;
  @attr declare trackingPixelHtml: string | null;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;
  @belongsTo('employee', { async: false, inverse: null })
  declare employee: EmployeeModel;

  /**
   * Whether this notification has been opened at least once
   */
  get isOpened(): boolean {
    return this.firstOpenedAt !== null;
  }

  [Type] = 'notification-history' as const;
}
